/** Kurze Begrüßung mit geöffnetem Dokument — kein Auto-Analyse-/Frist-Pfad. */
export const DOCUMENT_GREETING_RE =
  /^(hallo|grüß\s*gott|gruss\s*gott|guten\s+(tag|morgen|abend|nachmittag)|servus|moin)[\s!.?,]*$/i;

export function isDocumentWelcomeGreeting(text: string): boolean {
  const t = text.trim();
  if (!t || t.length > 48) return false;
  return DOCUMENT_GREETING_RE.test(t);
}

export type DocumentWelcomeActionId = 'erklaeren' | 'bearbeiten' | 'fristen' | 'zusammenfassen';

export interface DocumentWelcomeAction {
  id: DocumentWelcomeActionId;
  label: string;
}

/** Platzhalter im Chat-Eingabefeld nach Klick auf „Fragen zum Dokument“. */
export const DOCUMENT_QUESTION_INPUT_PLACEHOLDER = 'Was möchtest Du zum Dokument wissen?';

export function buildDocumentWelcomeActions(): DocumentWelcomeAction[] {
  return [
    { id: 'erklaeren', label: 'Fragen zum Dokument' },
    { id: 'bearbeiten', label: 'Im Editor bearbeiten' },
    { id: 'fristen', label: 'Fristen prüfen' },
    { id: 'zusammenfassen', label: 'Dokument analysieren' },
  ];
}

/** Explizite Vollanalyse / LEXCORE — hebt den Fragen-Chip-Modus auf (UAT 10.07.2026). */
const EXPLICIT_DOC_ANALYZE_RE =
  /\b(analysier(?:e|en)?\s+(?:das\s+)?(?:geöffnete\s+)?dokument|dokument\s+analysier)/i;
const EXPLICIT_PARAGRAPH_ANALYZE_RE = /\banalysier(?:e|en)?\s+(?:absatz|§|paragraph)/i;
const EXPLICIT_LEXCORE_LOOKUP_RE = /\b(nachschlag(?:en)?\s+in\s+lexcore|lexcore\s+nachschlag)/i;

export type DocumentQuestionSendIntent = 'document_question' | 'zusammenfassen' | 'rechtsfrage';

export function resolveDocumentQuestionSendIntent(text: string): {
  intent: DocumentQuestionSendIntent;
  chipAction?: 'question';
} {
  const t = text.trim();
  if (EXPLICIT_DOC_ANALYZE_RE.test(t) || EXPLICIT_PARAGRAPH_ANALYZE_RE.test(t)) {
    return { intent: 'zusammenfassen' };
  }
  if (EXPLICIT_LEXCORE_LOOKUP_RE.test(t)) {
    return { intent: 'rechtsfrage' };
  }
  return { intent: 'document_question', chipAction: 'question' };
}

export function buildDocumentWelcomeText(displayName: string): string {
  const name = displayName.trim() || 'Ihr geöffnetes Dokument';
  return (
    `Guten Tag. Ich sehe „${name}" im Editor.\n\n` +
    'Womit darf ich Ihnen helfen? Wählen Sie eine der Optionen unten — ich starte keine Analyse oder Fristenprüfung ohne Ihre Auswahl.\n\n' +
    'Hinweis: Ich ersetze keine anwaltliche Beratung.'
  );
}

const DOC_WELCOME_STORAGE_PREFIX = 'arkorbit_portal_doc_welcome_v1__';

export function documentWelcomeStorageKey(customerId: string, documentId: string): string {
  return `${DOC_WELCOME_STORAGE_PREFIX}${customerId}__${documentId}`;
}

/** Slice 1.3: Welcome-Chips pro Dokument (sessionStorage), globaler Chat-Verlauf bleibt. */
export function hasDocumentWelcomeBeenShown(customerId: string, documentId: string): boolean {
  try {
    return sessionStorage.getItem(documentWelcomeStorageKey(customerId, documentId)) === '1';
  } catch {
    return false;
  }
}

export function markDocumentWelcomeShown(customerId: string, documentId: string): void {
  try {
    sessionStorage.setItem(documentWelcomeStorageKey(customerId, documentId), '1');
  } catch {
    /* privater Modus / Quota */
  }
}
